import styled from '@emotion/styled'

import { forwardRef } from 'react'

import SearchBar from '@segment/matcha/components/SearchBar'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroComponents from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Hundreds of integrations`,
  description: `Power your tools with the data they need.`,
  partnerPage: (
    <>
      Need a hand getting your integrations set up? Find a{` `}
      <a href="https://segment.partnerpage.io/">consulting partner</a>
      {` `}
      to help.
    </>
  ),
}

interface HeroProps {
  query: string
  onQueryChange: (newQuery: string) => void
  isFetching: boolean
}

const Hero = forwardRef<HTMLDivElement, HeroProps>(({ query, isFetching, onQueryChange }, ref) => {
  return (
    <Wrapper ref={ref}>
      <HeroBase variant="centered">
        <HeroComponents.Copy>
          <CopyText.Heading tag="h1" variant="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pExtraLarge">
            {copy.description}
          </CopyText.Description>
        </HeroComponents.Copy>

        <HeroComponents.Contents>
          <SearchWrapper>
            <SearchBar
              dataHook="catalog-search-bar"
              appearance="twilioLight"
              placeholder="Search integrations..."
              aria-label="search"
              name="catalog_integrations_query"
              id="catalog_integrations_input"
              value={query}
              isLoading={isFetching}
              onChange={(_e, value) => onQueryChange(value ?? ``)}
              onClear={() => onQueryChange(``)}
              expanded={true}
            />
          </SearchWrapper>
          <StyledCopyTextBase centered={true}>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.partnerPage}
            </CopyText.Description>
          </StyledCopyTextBase>
        </HeroComponents.Contents>
      </HeroBase>
    </Wrapper>
  )
})

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const SearchWrapper = styled.div`
  max-width: 520px;
  width: 100%;
`

const StyledCopyTextBase = styled(CopyTextBase)`
  padding-top: 32px;
  position: relative;
  z-index: 1;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 56px;
  }
`

export default Hero
